module.exports = function(locale, preview) {
  return `
    {
      loginPageCollection(locale: "${locale}", preview: ${preview}, limit: 1) {
        items {
          sys {
            id
          }
          pageMetadata {
            pageTitle
            metaTitle
            metaKeywords
            metaDescription
          }
          slug
          imageset {
            smartphoneImage {
              url
            }
            desktopImage {
              url
            }
          }
        }
      }
    }
  `;
};
